import { Controller } from "@hotwired/stimulus"

export default class extends Controller {
  static targets = ["panel", "backdrop", "toggle"]

  connect() {
    this.handleResize = this.closeOnDesktop.bind(this)
    this.handleEscape = this.handleKeydown.bind(this)
    window.addEventListener("resize", this.handleResize)
    document.addEventListener("keydown", this.handleEscape)
    this.closeOnDesktop()
  }

  disconnect() {
    window.removeEventListener("resize", this.handleResize)
    document.removeEventListener("keydown", this.handleEscape)
  }

  toggle() {
    if (this.isDesktop()) return
    this.isOpen() ? this.close() : this.open()
  }

  open() {
    if (this.isDesktop()) return

    if (this.hasPanelTarget) {
      this.panelTarget.classList.remove("hidden", "-translate-x-full")
      this.panelTarget.classList.add("translate-x-0")
    }

    if (this.hasBackdropTarget) {
      this.backdropTarget.classList.remove("pointer-events-none", "opacity-0", "hidden")
      this.backdropTarget.classList.add("opacity-100")
    }

    if (this.hasToggleTarget) {
      this.toggleTarget.setAttribute("aria-expanded", "true")
    }

    document.body.classList.add("overflow-hidden")
  }

  close(event) {
    if (this.isDesktop()) return
    if (event && event.type === "click" && event.currentTarget === this.panelTarget) return

    if (this.hasPanelTarget) {
      this.panelTarget.classList.add("-translate-x-full")
      this.panelTarget.classList.remove("translate-x-0")
      window.setTimeout(() => {
        if (!this.isDesktop()) {
          this.panelTarget.classList.add("hidden")
        }
      }, 200)
    }

    if (this.hasBackdropTarget) {
      this.backdropTarget.classList.add("pointer-events-none", "opacity-0")
      this.backdropTarget.classList.remove("opacity-100")
      this.backdropTarget.classList.add("hidden")
    }

    if (this.hasToggleTarget) {
      this.toggleTarget.setAttribute("aria-expanded", "false")
    }

    document.body.classList.remove("overflow-hidden")
  }

  handleKeydown(event) {
    if (event.key === "Escape" && this.isOpen()) {
      this.close()
    }
  }

  closeOnDesktop() {
    if (this.isDesktop()) {
      document.body.classList.remove("overflow-hidden")
      if (this.hasBackdropTarget) {
        this.backdropTarget.classList.add("pointer-events-none", "opacity-0", "hidden")
        this.backdropTarget.classList.remove("opacity-100")
      }
      if (this.hasPanelTarget) {
        this.panelTarget.classList.remove("hidden", "-translate-x-full")
        this.panelTarget.classList.add("lg:flex")
      }
      if (this.hasToggleTarget) {
        this.toggleTarget.setAttribute("aria-expanded", "false")
      }
    }
  }

  isOpen() {
    return this.hasPanelTarget && this.panelTarget.classList.contains("translate-x-0") && !this.panelTarget.classList.contains("hidden")
  }

  isDesktop() {
    return window.matchMedia("(min-width: 1024px)").matches
  }

  backdropTargetConnected(element) {
    element.classList.add("hidden")
  }
}
